var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-loading',{attrs:{"size":"24px","vertical":""}},[_vm._v("加载中...")]),_c('iframe',{staticStyle:{"display":"flex","align-items":"center","overflow":"hidden"},attrs:{"srcdoc":_vm.alipayData,"frameborder":"no","border":"0","marginwidth":"0","marginheight":"0","scrolling":"no","width":"100%","height":"380"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }